import { render, staticRenderFns } from "./layout-full.vue?vue&type=template&id=12f94722&scoped=true&"
import script from "./layout-full.vue?vue&type=script&lang=ts&"
export * from "./layout-full.vue?vue&type=script&lang=ts&"
import style0 from "./layout-full.vue?vue&type=style&index=0&id=12f94722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f94722",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/h8udm/release-builds/release-2.6/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f94722')) {
      api.createRecord('12f94722', component.options)
    } else {
      api.reload('12f94722', component.options)
    }
    module.hot.accept("./layout-full.vue?vue&type=template&id=12f94722&scoped=true&", function () {
      api.rerender('12f94722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layout-full.vue"
export default component.exports